import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import DataTable from "react-data-table-component";
import { AddNewRowButoon } from "../../../../Constant";
import { ADD_ROW_COLUMN, ADD_ROW_DATA } from "../../../../Pages/DataTable/ApiDataTablesData";

const AddRows = () => {
  const [tableData, setTableData] = useState(ADD_ROW_DATA);
  const getRandomFloat = (min: number, max: number) => {
    const genrateRandom = Math.random() * (max - min) + min;
    return parseFloat(genrateRandom.toFixed(2));
  };

  const addNewRow = () => {
    const minimumValue = 10;
    const maximumValue = 100;
    const tempData = {
      column1: tableData[tableData.length - 1].column1 + 10,
      column2: getRandomFloat(minimumValue, maximumValue),
      column3: getRandomFloat(minimumValue, maximumValue),
      column4: getRandomFloat(minimumValue, maximumValue),
      column5: getRandomFloat(minimumValue, maximumValue),
    };
    setTableData([...tableData, tempData]);
  };
  return (
    <Col sm="12">
      <Card>
        <CardBody>
          <Btn color="primary" className="mb-3" onClick={addNewRow}>
            {AddNewRowButoon}
          </Btn>
          <div className="table-responsive">
            <div id="API-1" className="dataTables_wrapper">
              <DataTable data={tableData} columns={ADD_ROW_COLUMN} striped={true} pagination className="display" />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AddRows;
